import React from 'react';
import { Button, FadeIn } from '../ui';
export function FinalCTA() {
  return <section className="py-24 md:py-32 bg-atrium-green text-atrium-ivory relative overflow-hidden" data-id="element-219">
      {/* Decorative background lines */}
      <div className="absolute top-0 left-0 w-full h-full pointer-events-none opacity-10" data-id="element-220">
        <div className="absolute top-1/4 left-0 w-full h-[1px] bg-atrium-ivory" data-id="element-221" />
        <div className="absolute top-3/4 left-0 w-full h-[1px] bg-atrium-ivory" data-id="element-222" />
        <div className="absolute top-0 left-1/4 w-[1px] h-full bg-atrium-ivory" data-id="element-223" />
        <div className="absolute top-0 left-3/4 w-[1px] h-full bg-atrium-ivory" data-id="element-224" />
      </div>

      <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center relative z-10" data-id="element-225">
        <FadeIn data-id="element-226">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif mb-6 leading-tight" data-id="element-227">
            Speak with the family behind the build
          </h2>
          <p className="text-atrium-ivory/70 max-w-xl mx-auto mb-12 leading-relaxed" data-id="element-228">
            Book a private design consultation, call us directly, or send an
            enquiry using the form below.
          </p>

          <div className="flex flex-col sm:flex-row flex-wrap justify-center items-center gap-6" data-id="element-229">
            <Button variant="secondary" as="a" href="#enquire" className="bg-atrium-ivory text-atrium-green border-transparent hover:bg-atrium-ivory/90 hover:text-atrium-green" data-id="element-230">
              Book a Private Design Consultation
            </Button>
            <Button variant="secondary" as="a" href="tel:+61863108888" className="border-atrium-ivory text-atrium-ivory hover:bg-atrium-ivory hover:text-atrium-green" data-id="element-231">
              Call (08) 6310 8888
            </Button>
          </div>

          <div className="mt-10 flex flex-col sm:flex-row justify-center items-center gap-8" data-id="element-232">
            <a href="#latitude" className="text-sm font-medium tracking-wide hover:text-atrium-bronze transition-colors relative after:content-[''] after:absolute after:-bottom-1 after:left-0 after:w-full after:h-[1px] after:bg-atrium-bronze" data-id="element-233">
              Visit Latitude in Applecross
            </a>
            <a href="#enquire" className="text-sm font-medium tracking-wide hover:text-atrium-bronze transition-colors relative after:content-[''] after:absolute after:-bottom-1 after:left-0 after:w-full after:h-[1px] after:bg-atrium-bronze" data-id="element-234">
              Send an Enquiry
            </a>
          </div>
        </FadeIn>
      </div>
    </section>;
}